<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <template slot="label">
            <span>{{ $t(fieldConfig.label) }}</span>
            <ElPopover
                :visible-arrow="false"
                :width="366"
                placement="right"
                trigger="hover"
                popper-class="bio-search-setting__popover"
            >
                <AlgorithmPopover :options="store.algorithmOptions" />
                <PtIcon
                    slot="reference"
                    icon="SolidInfo"
                />
            </ElPopover>
        </template>
        <div>
            <ElSelect
                v-if="store.algorithmOptions.length > 1"
                v-model="fieldValue"
                class="search-preference__select"
                size="small"
                :placeholder="$t(fieldConfig.label)"
                :disabled="store.settingValues.automatic"
                @change="onChange"
            >
                <template
                    v-for="option in store.algorithmOptions"
                >
                    <ElOption
                        v-if="!(store.isShort && option.value === 'megablast')"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                    />
                </template>
            </ElSelect>
            <span
                v-else
                class="search-preference__optionText"
            >
                {{ displayValue }}
            </span>
        </div>
    </FieldItem>
</template>

<script>
import Popover from 'element-ui/lib/popover';
import PtIcon from '@patsnap-biz/icon';
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import { FieldItemMixin } from './mixins';
import FieldItem from '../components/FieldItem.vue';
import AlgorithmPopover from '../explanations/AlgorithmPopover.vue';

export default {
    components: {
        FieldItem,
        ElPopover: Popover,
        PtIcon,
        AlgorithmPopover,
        ElSelect: Select,
        ElOption: Option,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'algorithm',
        },
    },
    computed: {
        displayValue() {
            const option = this.store.algorithmOptions.find((o) => o.value === this.fieldValue);
            return option?.label || '';
        },
    },
    methods: {
        onChange() {
            this.store.afterChangeType(true);
            this.syncChange();
        },
    },
};
</script>
